import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  assetsTableContainer: {
    height: '100%',
    position: 'relative',
    boxShadow: theme.shadows[2],
    borderRadius: 4,
    backgroundColor: theme.vars.palette.background.elevation2,
    gridRow: 'span 4',
    [theme.breakpoints.down('xl')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1'
    },
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 1',
      gridRow: 'span 1'
    }
  },
  noData: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    color: theme.vars.palette.text.secondary
  }
}));

export default useStyles;
